module.exports = __webpack_public_path__ + "media/images/voices/bg-mv-99610734cd14abf9d432f6bb95815956.jpg";